import React, { useEffect } from 'react';
import { FaAlignJustify } from 'react-icons/fa';
import Aos from 'aos';
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';
  

const Nav = () => {
    useEffect(() => {
        Aos.init({duration:1000});
    },[])
    const [state,setState] = React.useState(true);
    return (
        <nav className="navbarr">
            <div className="containerr" >
                <div className="navbar-containerr ">
                <ul className="navbar__left ">
                    <div className="navbar__left-logo ">
                    <img height="90px"  src="https://i.ibb.co/qrGJNBs/freeLogo.jpg" alt="freeLogo" border="0"/>
                    </div>
                </ul>
                {state ?
                 <ul className="navbar__right">
                 <li><Link to="/home">Home</Link></li>
                 <li><Link to="/services">Services</Link></li>
                 <li><Link to="/about">About</Link></li>
                 <li><Link to="/skills">Skills</Link></li>
                 <li><Link to="/photography">Photography</Link></li>
                 <li><Link to="/contact">Contact</Link></li> 
                 </ul> : ("")}
               
                </div>
               
            </div>
            <div className="toggle" onClick={() => setState(!state)}><FaAlignJustify></FaAlignJustify></div>
        </nav>
    );
};

export default Nav;